import { render, staticRenderFns } from "./ErrorTicketCreation.vue?vue&type=template&id=ff8fe81a&scoped=true"
import script from "./ErrorTicketCreation.vue?vue&type=script&lang=js"
export * from "./ErrorTicketCreation.vue?vue&type=script&lang=js"
import style0 from "./ErrorTicketCreation.vue?vue&type=style&index=0&id=ff8fe81a&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ff8fe81a",
  null
  
)

export default component.exports